<template>
  <div class="order-container">
    <div class="address-wrapper" @click="selectAddress">
      <img class="location" src="../../../assets/icon/icons8-geo_fence@2x.png">
      <div v-if="address" class="address">
        <span>{{address.name}} {{address.mobile}}</span>
        <p>{{address.province}}{{address.city}}{{address.district}}{{address.address}}</p>
      </div>
      <div v-else class="address">
        <span>请选择您的收货地址</span>
      </div>
      <img class="arrow" src="../../../assets/icon/icons8-right_4@2x.png">
    </div>
    <div class="divide-line">
      <div class="line" v-for="item in 8" :key="item"><img src="../../../assets/icon/1@2x.png">
      <img src="../../../assets/icon/2@2x.png"></div>
    </div>
    <div class="award-wrapper">
      <img :src="awardOrder.award_cover">
      <div class="detail">
        <h1>{{awardOrder.award_name}}</h1>
        <p>{{awardOrder.award_intro}}</p>
        <span>￥{{awardOrder.award_price}}</span>
      </div>
    </div>
    <div class="tips-wrapper">
      <span>注意：兑换实物奖品时请您出示中奖瓶标和二维码。</span>
    </div>
    <div class="bottom-wrapper">
      <div class="botton" @click="receiveAward">领取奖品</div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import qs from 'qs'
import { mapGetters } from 'vuex'
import area from '@/util/area'
import { Toast } from 'vant'
import { Dialog } from 'vant'

Vue.use(Dialog)
Vue.use(Toast)

export default {
  name: 'AwardReceive',
  data() {
    return {
      area: area,
      logId: this.$route.query.logId,
      awardOrder: {}
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'address'])
  },
  created() {
    this.getAwardOrder()
  },
  methods: {
    /**
     * 获取收货地址
     */
    getAddress() {
      var that = this
      var url = '/user/address/' + this.$route.params.addressId
      this.axios.get(url).then(function(res) {
        that.address = res.data
      }).catch(function(error) {
        console.log(error)
      })
    },

    /**
     * 获取中奖订单详情
     */
    getAwardOrder() {
      var that = this
      var url = '/activity/award/log/' + this.logId + '/'
      this.axios.get(url).then(function(res) {
        if (!res.code) {
          that.awardOrder = res.data
        }
      })
    },

    receiveAward() {
      if (!this.address) {
        return Toast('请选择地址')
      }
      var that = this
      var params = {
        name: this.address.name,
        mobile: this.address.mobile,
        address: this.address.address,
        id: this.awardOrder.id
      }
      this.axios.post('/activity/award/receive/', qs.stringify(params)).then(function(res) {
        if (!res.code) {
          Dialog.alert({
            title: '提示',
            message: '订单已提交，您可以在「我的中奖记录」中关注物流信息，我们将会第一时间为您发货，请您耐心等待。'
          }).then(() => {
            that.$router.go(-1)
          })
        } else {
          Toast(res.message)
        }
      }).catch(function(error) {
        console.log(error)
        Toast('领取失败')
      })
    },

    selectAddress() {
      this.$router.push({ path: '/user/address', query: { action: 'select' }})
    }
  }
}
</script>

<style lang="scss" scoped>
.order-container{
  .address-wrapper{
    height: 73px;
    padding: 0 20px;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    .location{
      width: 14px;
      height: 16px;
    }
    .address{
      margin-left: 20px;
      line-height: 20px;
      span{
        color: #4a4a4a;
        font-size: 14px;
        font-weight: 600;
      }
      p{
        width: 280px;
        color: #747474;
        font-size: 12px;
        font-weight: 400;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
    }
    .arrow{
      width: 6px;
      height: 10px;
      position: absolute;
      right: 20px;
    }
  }
  .divide-line{
    margin-top: -5px;
    display: flex;
    white-space: nowrap;
    .line{
      margin-left: 3px;
      img{
        width: 20px;
        height: 3px;
      }
    }
  }
  .award-wrapper{
    height: 117px;
    padding: 0 15px;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    img{
      width: 90px;
      height: 90px;
    }
    .detail{
      line-height: 25px;
      margin-left: 10px;
      h1{
        color: #4a4a4a;
        font-size: 16px;
        font-weight: 400;
        margin: 0;
      }
      p{
        color: #aaaaaa;
        font-size: 12px;
        font-weight: 400;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: wrap;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      span{
        color: #ff6d63;
        font-size: 12px;
        font-weight: 600;
      }
    }
  }
  .tips-wrapper {
    padding: 12.5px;
    span {
      font-size: 14px;
      color: #4A4A4A;
    }
  }
  .bottom-wrapper{
    width: 100%;
    height: 60px;
    background-color: #ffffff;
    position: fixed;
    bottom: 0;
    .botton{
      width: 350px;
      height: 45px;
      margin: 8px auto;
      border-radius: 5px;
      background-color: #5e5ef6;
      color: #ffffff;
      font-size: 16px;
      font-weight: 400;
      line-height: 45px;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/award/receive.vue